/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Saving_ProjectInputs */



/**
* | output |
* | --- |
* | "Saving project..." |
*
* @param {Saving_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const saving_project = /** @type {((inputs?: Saving_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Saving_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrement du projet...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt retten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salvataggio del progetto...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект по сохранению...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardando proyecto...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存项目……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトを保存しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बचत परियोजना...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto de economia...")
	return /** @type {LocalizedString} */ ("Saving project...")
});